<template>
  <el-dialog
    title="检查人员列表"
    :visible.sync="dialogVisible"
    class="dialog_"
    append-to-body
    @close="closeForm"
    width="1000px">
    <div class="container">
      <div style="width: 100%">
        <div class="fl-wrap mg-tp-sm">
          <div class="search-item">
            <span class="span">检查人员名称</span>
            <el-input clearable size="mini" style="width:200px;margin-right:15px" v-model="searchForm.name"  class="item" placeholder="请输入检查人员名称"></el-input>
          </div>
          <div class="search-item">
            <span class="span">联系电话</span>
            <el-input clearable size="mini" style="width:200px;margin-right:15px" v-model="searchForm.phone"  class="item" placeholder="请输入联系电话"></el-input>
          </div>
          <el-button class="mg-lf-sm" style="height: 28px" size="mini" type="primary" @click="reset">重置</el-button>
          <el-button class="mg-lf-sm" style="height: 28px" size="mini" type="primary" @click="search">查询</el-button>
          <el-button class="mg-lf-sm" style="height: 28px" size="mini" type="primary" @click="save">确定</el-button>
        </div>
        <div></div>
        <div class="mg-tp-sm">
          <el-table
            @select="select"
            @select-all="selectAll"
            ref="multipleTable"
            highlight-current-row
            :data="tableData"
            v-loading="loading"
            style="width: 100%"
            :header-cell-style="{padding: '8px 0',color: '#303133',backgroundColor: 'rgb(240,245,251)'}"
            :cell-style="{padding: '5px 0',color: '#303133'}"
            border
            stripe>
            <el-table-column
              type="selection"
              width="55">
            </el-table-column>
            <el-table-column
              prop="name"
              label="检查人员姓名"
              show-overflow-tooltip
              min-width="140">
            </el-table-column>
            <el-table-column
              prop="unit_name"
              show-overflow-tooltip
              label="所在单位"
              min-width="140">
            </el-table-column>
            <el-table-column
              prop="phone"
              label="联系电话"
              show-overflow-tooltip
              min-width="140">
            </el-table-column>
          </el-table>
          <el-row>
            <el-col :span="24">
              <div style="float:right;padding:10px">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-size="10"
                  layout="total, prev, pager, next, jumper"
                  :total="totalCount">
                </el-pagination>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
  </template>

  <script>
  import selectArea from '@/components/selectArea/selectArea'
  import Search from '@/Util/Search'
  import {api} from '@/api/api'
  export default {
    components: {
      Search,
      selectArea
    },
    data () {
      return {
        searchForm:{
          name: '',
          phone: ''
        },
        dialogVisible: true,
        staff: null,
        loading: false,
        jobOptions: [],
        tableData: [],
        checkedData: null, // 选中的节点
        currentPage: 1,
        totalCount: 0,
        parent_node_id: 0, // 父级ID
        parent_node_label: null, // 父级名称
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        callback: null,
        SelectionAll: {},
        SelectionTable: [],
        responsible_person: null
      }
    },
    mounted () {
      this.getGovCheckExpertList()
    },
    methods: {
      search() {
        this.currentPage = 1
        this.getGovCheckExpertList()
      },
      reset() {
        for(let key in this.searchForm) {
          this.searchForm[key] = null
        }
        this.search()
      },
      deleteStaff (row, index) {
        this.select({}, row)
        this.$nextTick(() => {
          this.getGovCheckExpertList()
        })
      },
      closeForm () {
        this.staff = null
        this.checkedData = null
        // this.$refs['table'].setCurrentRow()
        this.$el.parentNode.removeChild(this.$el);
      },
      save () {
        if (this.SelectionTable.length == 0) {
          return this.$message({
            type: 'warning',
            message: '请选择检查人员'
          })
        }
        if (this.callback && typeof(this.callback) === 'function') {
          this.callback(this.SelectionTable)
        }
        // this.$emit('getStaff', staff)
        this.dialogVisible = false
      },
      currentChange (currentRow) {
        if (currentRow) {
          this.staff = currentRow
        }
      },
      getGovCheckExpertList () {
        let params = {
          page_index: this.currentPage,
          page_size: 10
        }
        for (let key in this.searchForm) {
          if (this.searchForm[key] !== '') {
            params[key] = this.searchForm[key]
          }
        }
        this.loading = true
        this.$http.post(
          api['getGovCheckExpertList'],
          params
        ).then(response => {
          this.tableData = response.data.data
          this.$nextTick(() => {
            this.checkSelect()
          })
          this.totalCount = response.data.page_info.total_num
          this.loading = false
        }).catch((error) => {
          console.log(error)
        })
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this.getGovCheckExpertList()
      },
      select (selection, row) {
        for (let key in this.SelectionAll) {
          if (key == row.id) {
            delete this.SelectionAll[key]
            this.SelectionTable = Object.values(this.SelectionAll)
            return
          }
        }
        this.SelectionAll[row.id] = row
        this.SelectionTable = Object.values(this.SelectionAll)
      },
      selectAll (select) {
        for (let row of this.tableData) {
          if (select.length === 0) {
            delete this.SelectionAll[row.id]
          } else {
            this.SelectionAll[row.id] = row
          }
        }
        this.SelectionTable = Object.values(this.SelectionAll)
      },
      // 每次刷新时检查是否有选项，并设置已选中
      checkSelect () {
        for (let row of this.tableData) {
          if (this.SelectionAll.hasOwnProperty(row.id)) {
            this.$refs.multipleTable.toggleRowSelection(row,true)
          }
        }
      }
    }
  }
  </script>

  <style scoped>
    .container {
      display: flex;
      flex-wrap: nowrap;
    }
    .span {
      font-size: 14Px;
      line-height: 32Px;
      margin:0 5Px 10Px 0;
    }
    .item {
      width: 160Px;
      margin:0 15Px 10Px 0;
    }
    .left {
      margin-left: 15Px;
    }
    .title {
      font-size: 18Px;
      font-weight: 900;
    }
    .fl-wrap {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
    .mg-tp-sm {
      margin-top: 8Px;
    }
    .span {
      margin: 8Px;
    }
    .search-item {
      margin: 10Px 0;
    }
    .dialog_ >>> .el-dialog__body {
      padding: 0 30Px;
    }
  </style>



// WEBPACK FOOTER //
// src/components/selectExpert/selectExpertDialog.vue